import { createModel } from 'xstate/lib/model';

import baseEvents from 'features/Bento/libs/machines/config/baseEvents';
import { ApplicantType, ApplicationType } from 'features/Onboarding/types';

import { PersonalInfoModuleDataQuery } from '../graphql/queries/personalInfoModuleData.gql';
import { BusinessRoleSchema } from '../pages/BusinessRole/businessRoleSchema';
import { PersonalNameSchema } from '../pages/PersonalName/personalNameSchema';
import { CompanySupposedDirector } from '../types';

/**
 * We have to remap company to make it optional
 * @see https://github.com/dotansimha/graphql-code-generator/issues/8461
 */
type PersonalInfoModuleData = {
  viewer: Omit<PersonalInfoModuleDataQuery['viewer'], 'company'> & {
    company: PersonalInfoModuleDataQuery['viewer']['company'] | null;
  };
  applicationType: ApplicationType;
  applicantType: ApplicantType;
};

export type Context = {
  getModuleData: () => PersonalInfoModuleData;
};

const context: Context = {
  getModuleData: () => {
    throw new Error('NOT_IMPLEMENTED');
  },
};

const model = createModel(
  context,

  {
    events: {
      ...baseEvents,
      'error.platform.saveDirectorSelection': (data: Error) => ({ data }),
      SUBMIT_BUSINESS_ROLE: (data: BusinessRoleSchema) => ({ data }),
      SUBMIT_DIRECTOR_SELECTION: (data: CompanySupposedDirector) => ({
        data,
      }),
      SUBMIT_NON_OFFICER: () => ({}),
      SUBMIT_NOT_FOUND: () => ({}),
      SUBMIT_PERSONAL_NAME: (data: PersonalNameSchema) => ({ data }),
    },
  },
);

export default model;

export type Model = typeof model;
